// FILE: src/components/admin_pages/LotteryManagementLanding.js

import React, { useState } from 'react';
import {
    Container,
    Box,
    Typography,
    Card,
    CardContent,
    CardActionArea,
    Paper,
} from '@mui/material';
import {
    AdminPanelSettings,
    Security,
    Login,
    ArrowForward,
    EmojiEvents,
} from '@mui/icons-material';
import LoginAdminLottery from './LoginAdminLottery';

const LotteryManagementLanding = ({ onLogin }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);

    const handleCardClick = () => {
        setShowLoginModal(true);
    };

    const handleCloseModal = () => {
        setShowLoginModal(false);
    };

    return (
        <>
            <Box
                sx={{
                    minHeight: '100vh',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 4,
                }}
            >
                <Container maxWidth="md">
                    <Paper
                        elevation={12}
                        sx={{
                            borderRadius: 4,
                            overflow: 'hidden',
                            background: 'rgba(255, 255, 255, 0.95)',
                            backdropFilter: 'blur(10px)',
                        }}
                    >
                        <Box sx={{ p: 6, textAlign: 'center' }}>
                            {/* Header Section */}
                            <Box sx={{ mb: 4 }}>
                                <EmojiEvents
                                    sx={{
                                        fontSize: 60,
                                        color: 'primary.main',
                                        mb: 2,
                                        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))'
                                    }}
                                />
                                <Typography
                                    variant="h3"
                                    component="h1"
                                    fontWeight="bold"
                                    sx={{
                                        background: 'linear-gradient(45deg, #667eea, #764ba2)',
                                        backgroundClip: 'text',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        mb: 2,
                                    }}
                                >
                                    Lottery Management
                                </Typography>
                                <Typography
                                    variant="h6"
                                    color="text.secondary"
                                    sx={{ maxWidth: 600, mx: 'auto' }}
                                >
                                    Secure administrative access to view all registered teachers
                                </Typography>
                            </Box>

                            {/* Login Card */}
                            <Card
                                sx={{
                                    maxWidth: 400,
                                    mx: 'auto',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                                    }
                                }}
                            >
                                <CardActionArea onClick={handleCardClick}>
                                    <CardContent sx={{ p: 4 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <Security
                                                sx={{
                                                    fontSize: 40,
                                                    color: 'primary.main',
                                                    mr: 2
                                                }}
                                            />
                                            <Typography variant="h5" fontWeight="bold">
                                                Admin Sign In
                                            </Typography>
                                        </Box>

                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{ mb: 3 }}
                                        >
                                            Access restricted to authorized administrators only
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'primary.main',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <Login sx={{ mr: 1 }} />
                                            <Typography variant="button">
                                                Click to Sign In
                                            </Typography>
                                            <ArrowForward sx={{ ml: 1 }} />
                                        </Box>
                                    </CardContent>
                                </CardActionArea>
                            </Card>

                            {/* Security Notice */}
                            <Box sx={{ mt: 4, p: 3, bgcolor: 'rgba(25, 118, 210, 0.08)', borderRadius: 2 }}>
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Security Notice:</strong> This area is restricted to authorized personnel only.
                                    All access attempts are logged and monitored.
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Container>
            </Box>

            {/* Login Modal */}
            {showLoginModal && (
                <LoginAdminLottery
                    onLogin={onLogin}
                    onClose={handleCloseModal}
                />
            )}
        </>
    );
};

export default LotteryManagementLanding;
